import { api } from "./http-client";
import { BlockedEmail } from "../types/blocked-email";

export const blockedEmailsService = {
  list: async (): Promise<BlockedEmail[]> => {
    const res = await api.request<BlockedEmail[]>({
      url: "/admin/blocked-emails",
      method: "GET",
    });
    return res.data;
  },

  create: async (email: string): Promise<BlockedEmail> => {
    const res = await api.request<BlockedEmail>({
      url: "/admin/blocked-emails",
      method: "POST",
      data: { email },
    });
    return res.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.request({ url: `/admin/blocked-emails/${id}`, method: "DELETE" });
  },
};
